export function isSideMenuAppPartDisabled({ part, coach } = {}) {
  if (part === "CoachNutrition" && coach?.isOffline === true) {
    return true;
  }

  return false;
}
